var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const verticalEmbedDataNormalizer = (componentData) => {
  var _a, _b, _c, _d;
  const { selectedProduct, type } = componentData;
  const { html, description } = selectedProduct;
  if (html) {
    const additionalData = {};
    !selectedProduct.pageUrl && (additionalData.pageUrl = (_b = (_a = selectedProduct.html.match(/href="[^"]*/g)) == null ? void 0 : _a[0]) == null ? void 0 : _b.slice(6));
    if (type === "event") {
      !selectedProduct.scheduling && (additionalData.scheduling = (_c = selectedProduct.description.match(/[^|]+/)) == null ? void 0 : _c[0]);
      !selectedProduct.location && (additionalData.location = (_d = selectedProduct.description.match(/[^|]*$/)) == null ? void 0 : _d[0]);
    } else if (type === "booking") {
      !selectedProduct.durations && (additionalData.durations = description);
    }
    return __spreadProps(__spreadValues({}, componentData), {
      selectedProduct: __spreadValues(__spreadValues({}, additionalData), selectedProduct)
    });
  } else {
    return componentData;
  }
};

export { verticalEmbedDataNormalizer as default };
//# sourceMappingURL=verticalEmbedDataNormalizer.js.map
